import pagination from '../../utils/pagination'
import {
  PRODUCTS_BATCH_DELETE_REQUEST, PRODUCTS_BATCH_DELETE_SUCCESS, PRODUCTS_BATCH_DELETE_FAILURE,
  PRODUCTS_FETCH_MANY_REQUEST, PRODUCTS_FETCH_MANY_SUCCESS, PRODUCTS_FETCH_MANY_FAILURE,
  PRODUCTS_FETCH_REQUEST, PRODUCTS_FETCH_SUCCESS, PRODUCTS_FETCH_FAILURE,
  PRODUCTS_SAVE_REQUEST, PRODUCTS_SAVE_SUCCESS, PRODUCTS_SAVE_FAILURE,
  EMPTY_PRODUCTS,
  CLEAR_ERRORS
} from './types'

export default {
  [PRODUCTS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [PRODUCTS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [PRODUCTS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [PRODUCTS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [PRODUCTS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [PRODUCTS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [PRODUCTS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [PRODUCTS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [PRODUCTS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [PRODUCTS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [PRODUCTS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [PRODUCTS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_PRODUCTS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  }
}
